// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import FileUploadPresentationPropsDefault from "@insite/mobius/FileUpload/presentationProps";
import { xBaseTheme } from "@keller/XDL/types";
import { xScreen } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...FileUploadPresentationPropsDefault,
        buttonProps: {
            sizeVariant: "large",
            css: css`
                text-align: center;
                line-height: 13px;
                display: flex;
                align-items: center;
                ${xScreen("lte", "xs")} {
                    width: 100%;
                    margin: 15px 0 0;
                }
            `,
        },
    },
} as xBaseTheme["fileUpload"];
